export default "__VITE_ASSET__DFG5rTCf__"